<template>
  <div class="list-drawer" :class="{ 'is-detailed': isDetailedView }">
    <CommunityListGrid v-if="false && !isDetailedView" />
    <CommunityListAccordion v-if="!isDetailedView" @showMap="showMap" />
    <CommunityListDetail v-if="isDetailedView" />
    <div class="list-grid-floating-map">
      <button type="button" class="map-show btn btn-small btn-dark" @click="showMap">
        <IconMap />
        View Map
      </button>
    </div>
  </div>
</template>

<script>
import IconMap from '@/components/icons/IconMap';
import CommunityListDetail from '@/components/CommunityListDetail';
import CommunityListGrid from '@/components/CommunityListGrid';
import CommunityListAccordion from '@/components/CommunityListAccordion';

export default {
  name: 'CommunityListDrawer',
  components: {
    CommunityListGrid,
    CommunityListAccordion,
    CommunityListDetail,
    IconMap,
  },
  computed: {
    isDetailedView() {
      return this.$store.getters['ui/getPanelView'] === 'detail';
    },
  },
  methods: {
    showMap() {
      console.log('CommunityListDrawer showMap()', true);
      this.$store.dispatch('ui/setMapDisplay', { mapDisplay: true });
    },
  },
};
</script>
